<template>
  <div class="history">
    <Title :title="title" class="title" />
    <div class="container">
      <div class="swiper">
        <swiper :options="swiperOption" ref="historySwiper" id="historySwiper">
          <swiper-slide v-for="item in historys" :key="item.ID">
            <div class="item">
              <div class="box">{{item.PRONAME}}</div>
              <div class="content" v-html="item.MEMO"></div>
            </div>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
      </div>
    </div>
  </div>
</template>

<script>
import Title from '../Title/Title.vue'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import { mapState } from 'vuex'
import { getCommonUrl } from '@/util/lang.js'
const langType = {
  en: '76',
  'zh-CN': '75'
}
export default {
  components: {
    Title,
    swiper,
    swiperSlide
  },
  data() {
    return {
      title: {
        cn: '发展历程',
        en: 'development path'
      },
      swiperOption:{
        slidesPerView: 'auto',
        navigation: {
          nextEl: '.history .swiper .swiper-button-next',
          prevEl: '.history .swiper .swiper-button-prev',
        }
      },
      historys: []
    }
  },
  computed: {
    ...mapState({
      lang: state => state.lang
    })
  },
  watch: {
    lang: 'fetchDate'
  },
  mounted () {
    this.fetchDate(this.lang)
  },
  methods: {
    fetchDate (val) {
      if (val) {
        const currenttid = langType[val] || '75'
        const url = getCommonUrl(this.lang, currenttid)
        this.$$axios.get(url).then(res => {
          this.historys = res.data.proarr
        })
      }
    }
  }
}
</script>

<style scoped>
.history{
  background: url(/images/background4.jpg)no-repeat center / cover;
  padding: 50px 0;
}
.history .container{
  max-width: 1500px;
  margin: 0 auto;
}
.history .swiper{
  position: relative;
}
.history .swiper .swiper-container{
  padding: 150px;
}
.history .swiper .swiper-slide{
  width: 150px;
}
.history .swiper .swiper-slide:nth-of-type(even){
  margin-top: 110px;
}
.history .swiper .item{
  position: relative;
  width: 87px;
  margin-right: 50px;
}
.history .swiper .item::after{
  content: "";
  position: absolute;
  right: -63px;
  bottom: -36px;
  width: 85px;
  height: 0;
  border-top: 1px dotted #005598;
  transform: rotate(45deg);
  transform-origin: 100%;
}
.history .swiper .swiper-slide:nth-of-type(even) .item::after{
  bottom: auto;
  top: -36px;
  transform: rotate(-45deg);
}
.history .swiper .swiper-slide:last-of-type{
  width: 87px;
}
.history .swiper .swiper-slide:last-of-type .item::after{
  display: none;
}
.history .swiper .item .box{
  background: url(/images/historybg.png)no-repeat center;
  width: 87px;
  height: 99px;
  text-align: center;
  line-height: 99px;
  font-size: 16px;
  color: #fff;
  transition: 1s;
}
.history .swiper .item:hover .box{
  transform: rotateY(360deg);
}
.history .swiper .item .content{
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  width: 360px;
  height: 120px;
  background-color: #fff;
  padding: 20px;
  font-size: 14px;
  color: #3d3d3d;
  display: none;
}
.history .swiper .swiper-slide:nth-of-type(even) .item .content{
  top: 100%;
  bottom: auto;
}
.history .swiper .item:hover .content{
  display: block;
}
</style>


